import { render, staticRenderFns } from "./_slot.vue?vue&type=template&id=1e55f65e&scoped=true&lang=pug&"
import script from "./_slot.vue?vue&type=script&lang=js&"
export * from "./_slot.vue?vue&type=script&lang=js&"
import style0 from "./_slot.vue?vue&type=style&index=0&id=1e55f65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e55f65e",
  null
  
)

export default component.exports